module.exports = __webpack_public_path__ + "static/media/1-3-2.a74d8faa.png";